// Removing internal links (SEO directive)
function navLinkFn(e) {
  e.preventDefault();
  window.location.href = this.getAttribute('data-url');
  console.log(this.getAttribute('data-url'));
}

document.addEventListener('DOMContentLoaded', function() {
  var navLinks = document.getElementsByTagName('data-link'); // Fetch all data-link tags
  for (var i = 0; i < navLinks.length; i++) {
    if (navLinks[i].hasAttribute('data-url')) { // Check if they have a 'data-url' attribute
      navLinks[i].addEventListener('click', navLinkFn); 
    }
  }
});

// Filter dropdown
// function setupEventListeners() {
//   $("#facets-dropdown-container").off('click').on('click', function(e) {
//     e.preventDefault();

//     // Toggle open class for filter-dropdown-icon
//     $(".filter-dropdown-icon").toggleClass("open");

//     // Toggle the dropdown open/close state for facets-dropdown
//     const form = $("#facets-dropdown");
//     if (form.hasClass("is-open")) {
//       form.removeClass("is-open");
//     } else {
//       form.addClass("is-open");
//     }
//   });
//  }

 function setupEventListeners() {
  const dropdownContainer = document.getElementById('facets-dropdown-container');
  const dropdownIcon = document.querySelector('.filter-dropdown-icon');
  const facetsDropdown = document.getElementById('facets-dropdown');

  if(dropdownContainer){
    dropdownContainer.addEventListener('click', function(e) {
      e.preventDefault();

      // Toggle open class for filter-dropdown-icon
      if (dropdownIcon) {
        dropdownIcon.classList.toggle('open');
      }

      // Toggle the dropdown open/close state for facets-dropdown
      if (facetsDropdown) {
        facetsDropdown.classList.toggle('is-open');
      }
    });
  }

}

 

document.addEventListener("DOMContentLoaded", function () {

  //collection filters
  setupEventListeners();  
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      setupEventListeners();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  //collection/search product grid image slider
  //initGridSliders();

  if (document.querySelector('.shopify-section--main-collection') || document.querySelector('.shopify-section--main-search')) {
    // Use IntersectionObserver to watch each product container
    const productObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadDefferedImages(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px 200px 0px',
      threshold: 0.1
    });

    // Observe each product container
    document.querySelectorAll('.product-card').forEach(product => {
      productObserver.observe(product);
    });
  }
});

window.initGridSliders = function () {
  const sliders = document.querySelectorAll('.ezr-images-main');

  sliders.forEach(function (el) {
    const $el = $(el);

    const $slider = $el.find('.ezr-image-slider');
    const $prev = $el.find('.ezr-prev');
    const $next = $el.find('.ezr-next');

    $slider.slick({
      slidesToShow: 1,
      arrows: true,
      prevArrow: $prev,
      nextArrow: $next
    });
  });
};

function loadDefferedImages(productElement) {
  const lazyImages = productElement.querySelectorAll('img.deffered-image[data-src]');
  lazyImages.forEach(img => {
    img.src = img.dataset.src;
    img.srcset = img.dataset.srcset;
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  });
}